const decode = (value: string): string => {
	try {
		return decodeURIComponent(value);
	} catch {
		return "";
	}
};

// RFC 6266: the file service sends `filename*` (RFC 5987) beside an ASCII `filename` fallback whenever the name is not plain ASCII.
export const fileNameFromContentDisposition = (header: unknown, fallback: string): string => {
	if (typeof header !== "string" || header === "") return fallback;

	const extended = /(?:^|;)\s*filename\*\s*=\s*[^']*'[^']*'([^;]*)/i.exec(header);
	const decoded = extended ? decode(extended[1].trim()) : "";
	if (decoded) return decoded;

	const plain = /(?:^|;)\s*filename\s*=\s*(?:"((?:\\.|[^"\\])*)"|([^;]*))/i.exec(header);
	const name = plain ? (plain[1] !== undefined ? plain[1].replace(/\\(.)/g, "$1") : plain[2].trim()) : "";

	return name || fallback;
};
